import { queryOptions } from "@tanstack/react-query";

import { getMyAccelerator } from "~/lib/functions/accelerator";

/**
 * No user id in the key, like the learning queries: the server answers for the
 * signed-in coach, and a sign-in change reloads the page.
 */
export const acceleratorKeys = {
  mine: ["accelerator"] as const,
};

/**
 * What the Accelerator surfaces show the signed-in coach. The return from
 * Checkout refreshes it at once, so a few minutes of cache only spares the
 * price read on every course visit.
 */
export function acceleratorQueryOptions() {
  return queryOptions({
    queryKey: acceleratorKeys.mine,
    queryFn: () => getMyAccelerator(),
    staleTime: 5 * 60 * 1000,
  });
}
